import { useMemo } from "react";
import * as yup from "yup";

export const TOKEN_AMOUNT_KEY = "tokenAmount" as const;

interface UseTokenValidationProps {
    balance: string;
}

export function useTokenValidation({ balance }: UseTokenValidationProps) {
    return useMemo(
        () =>
            yup.object({
                [TOKEN_AMOUNT_KEY]: yup
                    .string()
                    .required("Amount is required")
                    .test({
                        name: "positive",
                        message: "Amount must be greater than 0",
                        test: (val) => (val ? Number(val) > 0 : false),
                    })
                    .test({
                        name: "balance",
                        message: `Insufficient balance (${balance} available)`,
                        test: (val) => (balance === null ? true : val ? Number(val) <= Number(balance) : false),
                    }),
            }),
        [balance],
    );
}
